import { CustomerInclType } from '../constants/customer-incl-type.js';
import { PriceAdjustmentBaseAmountType } from '../constants/price-adjustment-base-amount-type.js';
import { ProductInclType } from '../constants/product-incl-type.js';
// The legacy Fishbowl NOT NULL columns every volume tier writes; qty_applies is false because a tier is gated by min_cases, not qty_min/qty_max.
export const VOLUME_TIER_FIXED_COLUMNS = {
    isTier2: false,
    isAutoApply: true,
    customerInclTypeId: CustomerInclType.ALL,
    productInclTypeId: ProductInclType.ALL,
    qtyApplies: false,
    priceAdjustmentApplies: true,
    dateApplies: false,
    roundingApplies: false,
    roundingIsMinus: false,
    spcApplies: false,
    priceAdjustmentBaseAmountTypeId: PriceAdjustmentBaseAmountType.PRICE,
};
//# sourceMappingURL=volume-discount-fixed-columns.js.map